import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialInstitutionLaboratoryState: Dtos.InstitutionLaboratory & IRegistrationFormState = {
    id: null,
    laboratoryId: null,
    laboratory: null,
    institutionId: null,
    institution: null,
    dateCeased: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface IInstitutionLaboratoryReduxFormState {
    id: IFieldState<number>,
    laboratoryId: IFieldState<number>,
    institutionId:IFieldState<number>,
    dateCeased: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    saveAndReturn: IFieldState<boolean>
}